import React from "react";
import tw, { css } from "twin.macro";
//prettier-ignore
import { FaCheckCircle, FaChevronRight, FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";
import basicplan from "../../images/basicplan.svg";
import standardplan from "../../images/standardplan.svg";
import plusplan from "../../images/plusplan.svg";
import premiumplan from "../../images/premiumplan.svg";
import detailplanone from "../../images/detailplanone.svg";
import ReactTooltip from 'react-tooltip'
import SubscribeSection from "../SubscribeSection/SubscribeSection";
import covid19 from "../../images/covid-19.png";


import { motion } from "framer-motion";

function PricingSection({
  types,
  packages,
  subsPackageDescription,
  subsPlanFeatures,
  subsPlans,
  prepaidPackageDescription,
  detailPackageDescription,
  detailPlans,
  faqs,
  faqAnswers,
}) {
  const [faqAnswer, setFaqAnswer] = React.useState({
    index: "",
    answer: "",
  });
  const [selectedType, setSelectedType] = React.useState("Car Washing");
  const [packageType, setPackageType] = React.useState("Subscription");

  function handleFaqOpen(index) {
    setFaqAnswer({
      index: index,
      answer: faqAnswers[index],
    });
  }

  function handleTypeChange(type) {
    setSelectedType(type);
  }

  function handlePackageChange(glintPackage) {
    setPackageType(glintPackage);
  }

  const buttonVariants = {
    hover: {
      x: [0, 5, -5, 5, -5, 0],
      originX: 0,
    },
  };

  const linkVariants = {
    hover: {
      scale: 1.1,
      originX: 0,
    },
  };
  const [show,setShow] = React.useState(true);

  return (
    <>
      <div tw="bg-secondary xl:px-24 px-6 py-12">
        <div tw="container mx-auto ">
          <p tw="text-primary text-lg font-semibold">Pricing</p>
          <h1 tw="text-white sm:text-5xl text-4xl font-black xl:w-1/4 md:w-1/2 w-3/4 ">
            plans <span tw="">and services.</span>
          </h1>
        </div>
        <div tw="flex lg:flex-row flex-col mt-12">
          <div tw="xl:mr-24 lg:mr-14 flex lg:flex-col flex-row">
            {types.map((type) => (
              <div
                css={[
                  tw`border-2 rounded border-secondary lg:mt-4 mr-2`,
                  selectedType === type && tw`border-primary`,
                ]}
              >
                <motion.li
                  variants={buttonVariants}
                  whileHover="hover"
                  css={[
                    tw`text-white text-xs font-semibold list-none lg:mx-2 m-1 text-center hover:cursor-pointer`,
                  ]}
                  onClick={() => handleTypeChange(type)}
                >
                  {type}
                </motion.li>
              </div>
            ))}
          </div>
          <div tw="xl:w-1/2 lg:w-2/5">
            {selectedType === "Car Washing" ? (
              <div tw="flex py-4">
                {packages.map((glintPackage) => (
                  <p
                    css={[
                      tw`text-white text-sm font-semibold h-1/2 p-2 hover:text-primary hover:cursor-pointer`,
                      packageType === glintPackage &&
                        tw`bg-primary text-black text-sm font-semibold h-1/2 p-2 hover:text-black`,
                    ]}
                    onClick={() => handlePackageChange(glintPackage)}
                  >
                    {glintPackage}
                  </p>
                ))}
              </div>
            ) : null}
            {selectedType === "Car Washing" &&
            packageType === "Subscription" ? (
              <p tw="text-white xl:w-1/2 md:w-3/4 lg:m-0 m-2 text-sm">
                {subsPackageDescription}{" "}
                {/* <span tw="text-primary font-semibold">Glint Plus</span> */}
              </p>
            ) : selectedType === "Car Washing" &&
              packageType === "Prepaid Packages" ? (
              <p tw="text-white xl:w-1/2 md:w-3/4 lg:m-0 m-2 text-sm">
                {prepaidPackageDescription}
              </p>
            ) : selectedType === "Auto Detailing" ? (
              <p tw="text-white xl:w-1/2 md:w-3/4 lg:m-6 m-2 text-sm">
                {detailPackageDescription}
              </p>
            ) : null}
          </div>
          {selectedType === "Car Washing" && (
            <div>
              {subsPlanFeatures.map((planFeature) => (
                <div tw="flex items-center my-4">
                  <FaCheckCircle tw="flex-shrink-0 text-primary text-lg" />
                  <li
                    css={[tw`mx-4 text-white text-sm font-semibold list-none`]}
                  >
                    {planFeature}
                  </li>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <div tw="bg-secondary">
        {show?
        <div tw="container mx-auto xl:px-12 flex flex-col lg:items-end items-center">
          {selectedType === "Car Washing" && packageType === "Subscription" ? (
            subsPlans.map((plan) => (
              <div
                css={[
                  tw`xl:w-4/6 w-5/6 bg-tertiary 
                  lg:px-6 py-6 xl:mr-20 md:mx-4 my-6 flex lg:flex-row flex-col`,
                  plan.label === "plus" &&
                    tw`xl:w-4/6 bg-primary 
                  lg:px-6 py-6 xl:mr-20 md:mx-4 my-6 flex lg:flex-row flex-col`,
                ]}
              >
                <div tw="flex lg:flex-col lg:items-start justify-between md:flex-row md:items-center flex-col">
                  <img
                    src={
                      plan.label === "basic"
                        ? basicplan
                        : plan.label === "standard"
                        ? standardplan
                        : plan.label === "plus"
                        ? plusplan
                        : premiumplan
                    }
                    alt="Subscription Plan"
                    tw="mx-2 lg:mx-0"
                  />
                </div>
                <div tw="lg:w-2/5 w-3/4 lg:mx-auto mx-4 md:my-2 my-4">
                  <h1
                    css={[
                      tw`text-primary font-semibold text-lg`,
                      plan.label === "plus" &&
                        tw`text-black font-semibold text-lg`,
                    ]}
                  >
                    {plan.name}
                  </h1>
                  <p
                    css={[
                      tw`text-white text-sm`,
                      plan.label === "plus" && tw`text-black text-sm`,
                    ]}
                  >
                    {plan.description}
                  </p>
                  <div tw="my-2">
                    {plan.misc.map((m) => (
                      <li
                        css={[
                          tw`text-white text-xs font-normal list-none`,
                          plan.label === "plus" &&
                            tw`text-black text-xs font-normal list-none`,
                        ]}
                      >
                        {m}
                      </li>
                    ))}
                  </div>
                  <h1
                    css={[
                      tw`my-6 text-white text-3xl font-semibold`,
                      plan.label === "plus" &&
                        tw`my-4 text-black text-3xl font-semibold`,
                    ]}
                  >
                    ₹
                    <span
                      css={[
                        tw`text-white text-6xl font-bold`,
                        plan.label === "plus" &&
                          tw`text-black text-6xl font-bold`,
                      ]}
                    >
                      {plan.price}
                    </span>
                    <span
                      css={[
                        tw`text-white text-3xl font-bold` &&
                          plan.label === "plus" &&
                          tw`text-black text-3xl font-bold`,
                      ]}
                    >
                    </span>
                  </h1>
                  <a
                  onClick={()=>setShow(!show)}
                      // href={`https://chats.landbot.io/v3/H-797100-VFSPIRTE0401ECYW/index.html?plan=${plan.label}`}
                      // target="_blank"
                      // rel="noopener noreferrer" tw="hover:text-current "
                    >
                  <motion.p
                    variants={linkVariants}
                    whileHover="hover"
                    css={[
                      tw`text-secondary bg-primary text-sm font-semibold  rounded-full px-4 py-2 w-max cursor-pointer border border-2 border-primary`,
                      plan.label === "plus" &&
                        tw`text-primary bg-secondary text-sm font-semibold  rounded-full px-4 py-2 w-max cursor-pointer border border-2 border-secondary`,
                    ]}
                  >
                    
                      {plan.link}
                  
                  </motion.p>
                  </a>
                  {plan.label === "plus" && (
                    <p tw="text-black font-bold text-lg mt-4">*most popular...</p>
                  )}
                </div> 
              </div>
            ))
          ) : selectedType === "Car Washing" &&
            packageType === "Prepaid Packages" ? (
            <div
              css={[
                tw`xl:w-4/6 w-5/6 bg-tertiary 
              lg:px-6 py-6 xl:mr-20 md:mx-4 my-6 flex lg:flex-row flex-col`,
              ]}
            >
              <div tw="flex lg:flex-col lg:items-start md:flex-row md:items-center flex-col ">
                <p tw="text-white font-semibold">Coming Soon</p>
              </div>
            </div>
          ) : selectedType === "Auto Detailing" ? (
            detailPlans.map((detail) => (
              <div
                css={[
                  tw`xl:w-4/6 w-5/6 bg-tertiary 
                      lg:px-6 py-6 xl:mr-20 
                      md:mx-4 my-6 flex lg:flex-row flex-col`,
                ]}
              >
                <div tw="lg:w-5/12 lg:mr-24 md:flex md:flex-row lg:flex-col">
                  <div tw="sm:w-1/2 lg:w-3/4 px-2">
                    <h1 css={[tw`text-primary font-semibold text-lg`]}>
                      {detail.name}
                    </h1>
                    <p css={[tw`text-white text-sm`]}>{detail.description}</p>
                    <h1 css={[tw`my-6 text-white text-3xl font-semibold`]}>
                      ₹
                      <span css={[tw`text-white text-6xl font-bold`]}>
                        {detail.price}
                      </span>
                    </h1>
                    <a
                      href="http://wa.me/919384016213?text=Hi, I would like to Subscribe"
                      css={[tw`text-primary text-sm font-medium`]}
                    >
                      {detail.link}
                    </a>
                  </div>
                  <div tw="mt-4">
                    <img
                      src={detailplanone}
                      alt="Detail Plan - 1"
                      tw="mx-2 lg:mx-0 lg:w-full w-11/12"
                    />
                  </div>
                </div>
                <div tw="lg:px-10 lg:py-6 p-2">
                  <p tw="text-white text-xs font-semibold">
                    Time Taken: {detail.timeTaken}
                  </p>
                  <div tw="grid md:grid-cols-2 lg:grid-cols-none">
                    {detail.misc.map((m) => (
                      <div tw="flex items-center my-2">
                        <FaCheckCircle tw="flex-shrink-0 text-primary text-lg" />
                        <li
                          css={[
                            tw`mx-2 text-white text-sm font-semibold list-none`,
                          ]}
                        >
                          {m}
                        </li>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))
          ) : null}
          {/* : (
            <div
              css={[
                tw`xl:w-4/6 w-5/6 bg-tertiary 
        lg:px-6 py-6 xl:mr-20 md:mx-4 my-6 flex lg:flex-row flex-col`,
              ]}
            >
              <div tw="flex lg:flex-col lg:items-start md:flex-row md:items-center flex-col ">
                <p tw="text-white font-semibold">Coming Soon</p>
              </div>
            </div>
          ) */}
        </div>
        : 
        <>
        <motion.div
        animate={{ rotateY: -360 }}
        transition={{
          ease: "easeOut",
          duration: 0.25,          
        }} tw="h-auto"> 

          <img src={covid19} tw="top-0 absolute w-full h-full max-w-none" />
   
          <div tw="bg-gradient-to-r from-secondary to-tertiary opacity-90 relative h-full">
            <button data-tip="React-tooltip"  onClick={()=>setShow(!show)} tw="ml-[4vh] md:ml-[12vh] z-40 hover:scale-110 mt-2 bg-primary text-secondary md:text-2xl text-lg font-extrabold text-center md:p-2 p-2 md:h-full h-2/4">
                X
            </button>
          <ReactTooltip place="right" type="light" backgroundColor='#ffc043' textColor="#1b1b1b" tw="font-bold" effect="solid">
            Close
          </ReactTooltip>
            <SubscribeSection name="Pricing"/> 
          </div>      
        </motion.div>
        
        </> 
        }
      </div>
      <div tw="bg-secondary">
        <div tw="container mx-auto xl:px-24 sm:py-12 py-6 lg:flex items-center">
          <div tw="sm:m-14 m-4 divide-y divide-primary lg:w-1/2">
            {faqs.map((faq, index) => (
              <div
                key={`${index}-d`}
                tw="py-4 flex justify-between items-center"
              >
                <li key={`${index}-f`} tw="text-gray-300 list-none">
                  {faq}
                </li>
                {faqAnswer.answer !== "" && faqAnswer.index === index ? (
                  <FaChevronRight
                    key={`${index}-i`}
                    tw="text-primary hover:cursor-pointer"
                  />
                ) : (
                  <FaPlus
                    key={`${index}-i`}
                    tw="text-primary hover:cursor-pointer"
                    onClick={() => handleFaqOpen(index)}
                  />
                )}
              </div>
            ))}
          </div>
          {faqAnswer.answer && (
            <div tw="bg-gray-300 lg:w-1/3 lg:h-1/2 p-10">
              <p>{faqAnswer.answer}</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default PricingSection;
